
namespace RecordShield.Workspace {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    export class ProductsDialog extends Serenity.EntityDialog<ProductsRow, any> {
        protected getFormKey() { return ProductsForm.formKey; }
        protected getIdProperty() { return ProductsRow.idProperty; }
        protected getLocalTextPrefix() { return ProductsRow.localTextPrefix; }
        protected getNameProperty() { return ProductsRow.nameProperty; }
        protected getService() { return ProductsService.baseUrl; }

        protected form = new ProductsForm(this.idPrefix);
		private productItemsGrid: ProductItemsGrid;
        private loadedState: string;
		constructor() {
            super();

            this.productItemsGrid = new ProductItemsGrid(this.byId("ProductItemsGrid"));
            this.productItemsGrid.element.flexHeightOnly(1);
            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);

            this.tabs.on('tabsactivate', (e, i) => { this.arrange() });

        }
        protected validateBeforeSave() {
            var isValidate = super.validateForm();
            if (isValidate) {
                isValidate = super.validateBeforeSave();
            }
            if (this.form.TotalAllowedDuration.value == 0) {
                Q.alert("Total Allowed Duration cannot be Zero.");
                return false;
            }
            return isValidate;
        }
        getSaveState() {
            try {
                return $.toJSON(this.getSaveEntity());
            }
            catch (e) {
                return null;
            }
        }

        loadResponse(data) {
            super.loadResponse(data);
            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductItems', this.isNewOrDeleted());

            this.loadedState = this.getSaveState();
        }

        loadEntity(entity: ProductsRow) {
            super.loadEntity(entity);

            Serenity.TabsExtensions.setDisabled(this.tabs, 'ProductItems', this.isNewOrDeleted());

            this.productItemsGrid.productId = entity.Id;
        }

        private getNextProductCode() {
            RecordShield.Workspace.ProductsService.GetNextProductCode({}, response => {
                this.form.Code.value = response.ProductCode;
            });
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            if (this.isNew())
                this.getNextProductCode();

            this.productItemsGrid.productId = this.entityId;
            //Serenity.EditorUtils.setReadonly(this.form.ValidityInDays.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.Views.element, true);
            //Serenity.EditorUtils.setReadonly(this.form.WatchTime.element, true);
            Serenity.EditorUtils.setReadonly(this.form.Code.element, true);
            Serenity.EditorUtils.setReadonly(this.form.CustomerKey.element, true);
        }
    }
}